<template>
  <div class="contents_wrapper">
  <div class='contents'>
    <h2 class="large_label">注文書・請求書</h2>

    <p>こちらから注文書や請求書のひな型をダウンロードできます。</p>
    <p>ダウンロードしたファイルはご自由に編集・共有していただけます。</p>

    <select class="select_form" v-model="isBill">
      <option :value="true" selected>請求書</option>
      <option :value="false">注文書</option>
    </select>

    <button v-if="isBill" @click="generatePdf" class="blue-ellipse_button">請求書ダウンロード</button>
    <button v-else @click="generatePdf" class="blue-ellipse_button">注文書ダウンロード</button>

    <BillBlock
      v-if="isBill"
      :client-detail="clientDetail"
      :client-office="clientOffice"
      :operator-detail="operatorDetail"
      :operator-office="operatorOffice"
      :work="work" />

    <OrderBlock
      v-else
      :client-detail="clientDetail"
      :client-office="clientOffice"
      :operator-detail="operatorDetail"
      :operator-office="operatorOffice"
      :work="work" />
  </div>
  </div>
</template>

<script>
  import excel from "@/assets/js/functions/_core/excel";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import OrderBlock from "@/components/objects/block/bill/OrderBlock";
  import BillBlock from "@/components/objects/block/bill/BillBlock";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "CreatingBill",

    components: {OrderBlock, BillBlock},

    mixins: [excel, collection],

    data() {
      return {
        isBill: true,
        clientDetail: {},
        clientOffice: {},
        operatorDetail: {},
        operatorOffice: {},
        work: {},
      }
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.matchingId = location.pathname.replace(/^\/matching\/meeting\//, '');
      this.matchingId = this.matchingId.replace(/\/bill\/create\/*$/, '');

      await this.getDoc(
        COLLECTION_NAMES.MATCHINGS,
        this.matchingId,
        {}).then(async matching => {
        this.matching = matching;
        this.setTalker(matching);
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      await this.getDoc(COLLECTION_NAMES.WORKS, this.matching.work.id).then(async doc => {
        this.work = doc;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
      await this.getDoc(COLLECTION_NAMES.USER_DETAILS, this.matching.client.id).then(async doc => {
        this.clientDetail = doc;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
      await this.getDoc(COLLECTION_NAMES.USER_DETAILS, this.matching.operator.id).then(async doc => {
        this.operatorDetail = doc;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
      await this.getDoc(COLLECTION_NAMES.OFFICES, this.clientDetail.office.id).then(async doc => {
        this.clientOffice = doc;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
      await this.getDoc(COLLECTION_NAMES.OFFICES, this.operatorDetail.office.id).then(async doc => {
        this.operatorOffice = doc;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },

    methods: {
      generatePdf() {
        const fileName = this.isBill ? '請求書' : '注文書';
        this.downloadFromHTML(fileName);
      }
    }

  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $client_primary;

    > .contents {
      @include form-contents();

      > p {
        margin-top: 1rem;
        width: 100%;
      }
      > .select_form {
        align-self: center;
        margin-top: 3rem;
      }
      .blue-ellipse_button {
        margin: 2rem 0;
      }
      .table-to-export {
        display: none;
      }
    }
  }
</style>